import React from 'react';
import { PileData, WordData } from '../types/game';
import WordCard from './WordCard';

interface StockWasteAreaProps {
  stockPile: PileData;
  wastePile: PileData;
  allWordData: Map<string, WordData>;
  onDrawCard: () => void;
  onRecycleStock: () => void;
  onCardMoveStart: (word: string, sourcePileId: number) => void;
  onCardClick?: (word: string, sourcePileId: number) => void; // Ensure this prop is defined
  onAddToVocab: (wordData: WordData) => void;
}

const StockWasteArea: React.FC<StockWasteAreaProps> = ({
  stockPile,
  wastePile,
  allWordData,
  onDrawCard,
  onRecycleStock,
  onCardMoveStart,
  onCardClick,
  onAddToVocab
}) => {

  // Stock Pile 点击处理：有牌就发牌，没牌就回收
  const handleStockClick = () => {
    if (stockPile.cards.length > 0) {
      onDrawCard();
    } else {
      onRecycleStock();
    }
  };

  const wasteTopCard = wastePile.cards.length > 0 
    ? wastePile.cards[wastePile.cards.length - 1] 
    : null;

  const wasteTopWordData = wasteTopCard ? allWordData.get(wasteTopCard.word) : null;

  // Waste Pile 的顶牌可以被拖走
  const handleWasteDragStart = (word: string) => {
      onCardMoveStart(word, wastePile.pileId);
  };

  return (
    <div className="stock-waste-area">
      
      {/* Stock Pile (牌库) */}
      <div 
        className="pile stock-pile" 
        onClick={handleStockClick}
      >
        {stockPile.cards.length === 0 ? (
            <span className="recycle-icon">↺</span>
        ) : (
            // 模拟牌背，如果有多张牌，添加 stacked 类
            // 使用一个单独的容器来包裹牌背，这样可以保留 pile 的 inset 效果
            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className={`card-back inner-card-back ${stockPile.cards.length > 1 ? 'stacked' : ''}`} />
            </div>
        )}
      </div>

      {/* Waste Pile (废牌/展示区) */}
      <div className="pile waste-pile">
        {wasteTopCard && wasteTopWordData && (
             <WordCard 
                data={wasteTopWordData}
                isDraggable={true} // Waste 顶牌总是可拖拽
                isFaceUp={true}
                stackIndex={0} // 在 Waste 区不需要层叠
                onDragStart={handleWasteDragStart}
                onCardClick={(w) => onCardClick && onCardClick(w, wastePile.pileId)}
                onAddToVocab={onAddToVocab} 
            />
        )}
      </div>
    </div>
  );
};

export default StockWasteArea;
